module.exports = __webpack_public_path__ + "53434b522f6217d69feddb0c70bfed77.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img-layout/bg-white-opacity.png
 ** module id = 539
 ** module chunks = 1
 **/